// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"app-components-staticpages-blocks-headerblock--wrapper","withBg":"app-components-staticpages-blocks-headerblock--withBg"};